import React, { useEffect, useRef, createContext } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { logout, loadCredentials } from 'src/redux/slices/auth';
import { setSocketAuth, resetSocketState } from 'src/redux/slices/socketStates';
const LoggingContext = createContext(null);

const LoggingProvider = ({ children }) => {
  const dispatch = useDispatch();
  const lastEventTimestamp = useRef(0);

  useEffect(() => {
    const handleStorageChange = event => {
      if (event.key === 'auth_event') {
        const authEvent = JSON.parse(event.newValue);
        const currentPath = window.location.pathname.split('/')[1]; // Get the first part after "/"
        const eventPath = authEvent?.location?.split('/')[1];

        // Only proceed if paths match
        if (currentPath === eventPath) {
          if (
            authEvent.type === 'logout' &&
            authEvent.timestamp - lastEventTimestamp.current > 500
          ) {
            lastEventTimestamp.current = authEvent.timestamp;
            dispatch(resetSocketState());
            dispatch(logout());
          }
          if (
            authEvent.type === 'login' &&
            authEvent.timestamp - lastEventTimestamp.current > 500
          ) {
            lastEventTimestamp.current = authEvent.timestamp;
            dispatch(setSocketAuth(authEvent));
            dispatch(loadCredentials(authEvent));
          }
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [dispatch]);

  return null;
};

export default LoggingContext;
export { LoggingProvider };
